import styled from 'styled-components'

export const StyledTreeContainer = styled.div`
  width: 100%;
`
